module.exports = __webpack_public_path__ + "static/media/seer.deaefacf.jpg";